import { render, staticRenderFns } from "./EvaluacionImpactoPagination.vue?vue&type=template&id=7148f942&"
import script from "./EvaluacionImpactoPagination.vue?vue&type=script&lang=js&"
export * from "./EvaluacionImpactoPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports